import React, { useContext, useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
  useLocation,
  useNavigate,
} from "react-router-dom";

import Footer from "./components/home/Footer/Footer";
import FooterBottom from "./components/home/Footer/FooterBottom";
import Header from "./components/home/Header/Header";
import About from "./pages/About/About";
import SignIn from "./pages/Account/SignIn";
import SignUp from "./pages/Account/SignUp";
import Cart from "./pages/Cart/Cart";
import Notices from "./pages/Notices/Notices";
import Home from "./pages/Home/Home";
import Receive from "./pages/Receive/Receive";
import Offer from "./pages/Offer/Offer";
import Payment from "./pages/payment/Payment";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Profile from "./pages/Profile/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import News from "./pages/News/News";
import { UserConfigProvider, UserConfigContext } from "./context/UserConfigContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import Forget from "./pages/Forget/Forget";
import Favorite from "./pages/Favorite/Favorite";
import Recover from "./pages/Recover/Recover";
import Redirect from "./pages/Redirect/Redirect";
import Logistic from "./pages/Logistic/Logistic";
import Configuracion from "./pages/Configuracion/Configuracion";
import Tracking from "./pages/Tracking/Tracking";
import Checkout from "./pages/Checkout/Checkout";

import Presupuestos from "./pages/Presupuestos/Presupuestos";
import Pedidos from "./pages/Pedidos/Pedidos";

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { config1 } = useContext(UserConfigContext);

  const excludedPaths = ["/signin", "/signup", "/forget", "/recuperaclave", "/checkout"];
  const showWhatsApp = !excludedPaths.includes(location.pathname.toLowerCase());

  useEffect(() => {
    const navType = performance.getEntriesByType("navigation")[0]?.type;

    // Guardar la última ruta válida (no excluida)
    if (!excludedPaths.includes(location.pathname.toLowerCase())) {
      localStorage.setItem("lastPath", location.pathname);
    }

    // Borrar sesiones solo si:
    // - no es recarga (F5)
    // - no es navegación con atrás/adelante
    // - y la ruta actual es excluida (saliste del ecommerce)
    if (
      navType !== "reload" &&
      navType !== "back_forward" &&
      excludedPaths.includes(location.pathname.toLowerCase())
    ) {
      localStorage.clear();
      sessionStorage.clear();
      // console.log("Sesiones borradas por salir de ecommerce");
    }
  }, [location.pathname]);

  // Manejo para botón atrás en /checkout (volver a la página anterior)
  useEffect(() => {
    if (location.pathname === "/checkout") {
      window.onpopstate = () => {
        navigate(-1);
      };
    }
    return () => {
      window.onpopstate = null;
    };
  }, [location.pathname, navigate]);
  
  return (
    <div>
      <Header />
      <ScrollRestoration />
      <Outlet />
      <Footer />
      <FooterBottom />

      {/* WhatsApp flotante */}
      {showWhatsApp && config1?.config_ecommerce?.mobile && (
        <a
          href={`https://wa.me/549${config1.config_ecommerce.mobile}?text=${encodeURIComponent(
            `¡Hola! Estoy en la tienda ${
              config1.empresa?.fantasia || config1.empresa?.nombre
            } y quiero pedir más información.`
          )}`}
          className="fixed bottom-5 right-5 z-50 hover:scale-110 transition-transform duration-300"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div
            style={{
              height: "50px",
              width: "50px",
              borderRadius: "50%",
              overflow: "hidden",
              boxShadow: "2px 2px 6px rgba(0,0,0,0.4)",
              textAlign: "center",
              lineHeight: "50px",
              backgroundColor: "#4dc247",
            }}
          >
            <svg
              style={{ fill: "white" }}
              viewBox="0 0 32 32"
              width="41px"
              height="50px"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.244-.73.244-1.088 0-.058 0-.144-.03-.215-.1-.172-2.434-1.39-2.678-1.39zm-2.908 7.593c-1.747 0-3.48-.53-4.942-1.49L7.793 24.41l1.132-3.337a8.955 8.955 0 0 1-1.72-5.272c0-4.955 4.04-8.995 8.997-8.995S25.2 10.845 25.2 15.8c0 4.958-4.04 8.998-8.998 8.998zm0-19.798c-5.96 0-10.8 4.842-10.8 10.8 0 1.964.53 3.898 1.546 5.574L5 27.176l5.974-1.92a10.807 10.807 0 0 0 16.03-9.455c0-5.958-4.842-10.8-10.802-10.8z"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </a>
      )}
    </div>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Layout />}>
        <Route index element={<ProtectedRoute element={<Home />} />} />
        <Route path="/about" element={<ProtectedRoute element={<About />} />} />
        <Route path="/Notices" element={<ProtectedRoute element={<Notices />} />} />
        <Route path="/Receive" element={<ProtectedRoute element={<Receive />} />} />
        <Route path="/Configuracion" element={<ProtectedRoute element={<Configuracion />} />} />
        <Route path="/offer" element={<Offer />} />
        <Route path="/product/:_id" element={<ProtectedRoute element={<ProductDetails />} />} />
        <Route path="/checkout" element={<ProtectedRoute element={<Checkout />} />} />
        <Route path="/cart" element={<ProtectedRoute element={<Cart />} />} />
        <Route path="/paymentgateway" element={<ProtectedRoute element={<Payment />} />} />
        <Route path="/profile" element={<ProtectedRoute element={<Profile />} />} />
        <Route path="/tracking" element={<ProtectedRoute element={<Logistic />} />} />
        <Route path="/analisis" element={<ProtectedRoute element={<Tracking />} />} />
        <Route path="/News" element={<News />} />
        <Route path="/Favorite" element={<Favorite />} />
        <Route path="/mis_presupuestos" element={<Presupuestos />} />
        <Route path="/mis_pedidos" element={<Pedidos />} />
      </Route>
      <Route path="/signup" element={<SignUp />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/Forget" element={<Forget />} />
      <Route path="/recuperaclave" element={<Recover />} />
      <Route path="/Redirect" element={<Redirect />} />
    </Route>
  ),
  { basename: "/ecommerce" }
  // { basename: "/mcd" }
);

function App() {
  return (
    <UserConfigProvider>
    <FavoritesProvider>
      <div className="font-bodyFont">
        <RouterProvider router={router} />
      </div>
    </FavoritesProvider>
  </UserConfigProvider>
  );
}

export default App;
